'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import {useEffect} from 'react';

/**
 * Глобальный обработчик ошибок для App Router.
 * Отлавливает необработанные ошибки и отправляет их в Sentry.
 * @see https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/#react-error-boundary
 */
export default function GlobalError({error: errorProp}: {error: Error & {digest?: string}}) {
  useEffect(() => {
    Sentry.captureException(errorProp);
  }, [errorProp]);

  return (
    <html lang="en">
      <body>
        <NextError statusCode={500} />
      </body>
    </html>
  );
}
